import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import TableView from '../Table/Table';
import { addBankStatementDescriptor, deleteBankStatementDescriptor, fetchBankStatementDescriptors } from '../../../redux/actions/DropdownActions';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';

const ProcessorPrefix = (props) => {

    const [delModelOpen, setDelModelOpen] = useState(false);
    const [addModelOpen, setAddModelOpen] = useState(false)

    const [data, setData] = useState(null)

    const [bankStmtDescriptorID, setBankStmtDescriptorID] = useState('')
    const [bankStmtDescriptor, setBankStmtDescriptor] = useState('')

    const [bankStmtDescriptorIDError, setBankStmtDescriptorIDError] = useState(false)
    const [, setBankStmtDescriptorError] = useState(false)


    useEffect(() => {
        props.fetchBankStatementDescriptors()
    }, [])

    const handleDeleteConfirmation = () => {

        let body = data?.data?.bankStatementDescriptor

        console.log(body)

        if (body) {
            props.deleteBankStatementDescriptor(body)
            setDelModelOpen(false)
        }



    }
    const handleDeleteButton = (value) => {
        setDelModelOpen(true)
    }

    const onCellClicked = (value) => {
        setData(value)
    }

    const handleAddButton = (value) => {
        setAddModelOpen(true)
    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'bankStmtDescriptorID':
                setBankStmtDescriptorID(targetValue)
                setBankStmtDescriptor(targetValue)
                setBankStmtDescriptorError(false)
                setBankStmtDescriptorIDError(false)
                break;
            default:
                break;

        }

    }


    const handleAdd = () => {

        let body = {}


        if (bankStmtDescriptor) {
            body.bankStatementDescriptor = bankStmtDescriptor
            body.bankStatementDescriptorID = bankStmtDescriptorID
            console.log(body)
            props.addBankStatementDescriptor(body)
            setAddModelOpen(false)
        }



    }

    const DELETE_CONFIRMATION = (

        <p className="lead text-dark">
            <SweetAlert danger showCancel
                confirmBtnText="Yes!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={handleDeleteConfirmation}
                onCancel={() => setDelModelOpen(!delModelOpen)}
            >


                Are you sure you want to remove - {data?.data?.bankStatementDescriptor}
            </SweetAlert>

        </p>
    )


    const ADD_HISTORY_FORM = (

        <p className="lead text-dark ">

            <SweetAlert showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAdd}
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>Bank Statement Form</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="mb-3">

                                        <div className="row gx-6">

                                            <div className="col-md-12 mb-12 mb-md-2">
                                          <label className={"col-md-6 " + (bankStmtDescriptorIDError ? 'text-danger' : '')}><b>Bank Statement Description</b></label>
                                              <input type="text" className="form-control fs-13px"
                                                    name="bankStmtDescriptorID"
                                                    value={bankStmtDescriptorID ? bankStmtDescriptorID : ''}
                                                    onChange={handleChange}
                                                    size='small'
                        />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>

    )

    const historyHeadings = {

        prefixHeadings: [
            { field: 'bankStatementDescriptor',  headerName: 'Bank Statement Descriptor', minWidth: 150 },
            {
                field: 'Action', tooltipField: 'action', headerName: '', minWidth: 80, cellRenderer: function (params) {
                    return <button className="btn btn-danger btn-icon btn-circle btn-sm me-1" onClick={handleDeleteButton}>X</button>
                }
            },
        ]
    }


    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-8">
                        <h4>Bank Statement Descriptors</h4>
                    </div>
                    <div className="col-xl-4">
                        <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-35px fs-09px" onClick={handleAddButton}>Add</button>
                    </div>
                </div>

            </PanelHeader>

            < TableView height={500} count={10} headings={historyHeadings.prefixHeadings} data={props.DROPDOWNREDUCER.bankStatementDescriptors} handleClick={onCellClicked} />

            {delModelOpen ?
                DELETE_CONFIRMATION : null
            }
            {addModelOpen ?
                ADD_HISTORY_FORM : null
            }
        </Panel>
    )

}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addBankStatementDescriptor,
    deleteBankStatementDescriptor,
    fetchBankStatementDescriptors
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorPrefix);

